// extracted by mini-css-extract-plugin
module.exports = {"item":"styles_item__1BfWN","icon":"styles_icon__18ULG","counters":"styles_counters__TVVsU","selected":"styles_selected__1JNCr","optionsContainer":"styles_optionsContainer__1NxdH"};